var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SectionContainerPage",
    [
      _c("SectionAssetStatusList", {
        attrs: {
          xs12: "",
          assetStatusList: _vm.assetStatusList,
          activityTypeList: _vm.activityTypeList,
          shouldShowSearch: true,
          toolbarActions: [
            {
              text: "Equipment Status",
              icon: "add",
              iconColor: "success",
              emitEvent: "onAddNewAssetStatusClicked",
            },
          ],
          isLoading: _vm.isLoading,
        },
        on: {
          onAddNewAssetStatusClicked: function ($event) {
            _vm.showDialogFormAssetStatusAdd = true
          },
          onEditAssetStatusClicked: (val) => [
            (_vm.assetStatusToEdit = val.assetStatusToEdit),
            (_vm.showDialogFormAssetStatusEdit = true),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormAssetStatusAdd", {
        attrs: {
          showDialog: _vm.showDialogFormAssetStatusAdd,
          isLoading: _vm.isLoading,
          activityTypeList: _vm.activityTypeList,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormAssetStatusAdd = false
          },
          onSubmitClicked: (val) => [_vm.onDialogFormAssetStatusAddSubmit(val)],
        },
      }),
      _vm._v(" "),
      _c("DialogFormAssetStatusEdit", {
        attrs: {
          showDialog: _vm.showDialogFormAssetStatusEdit,
          assetStatusToEdit: _vm.assetStatusToEdit,
          activityTypeList: _vm.activityTypeList,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormAssetStatusEdit = false
          },
          onSubmitClicked: (val) => [
            _vm.onDialogFormAssetStatusEditSubmit(val),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormConfirmation", {
        attrs: {
          showDialog: _vm.confirmationDialogShow,
          title: _vm.confirmationDialogTitle,
          message: _vm.confirmationDialogMessage,
          submitButtonText: _vm.confirmationDialogSubmitButtonText,
          submitButtonIcon: _vm.confirmationDialogSubmitButtonIcon,
          submitButtonColor: _vm.confirmationDialogSubmitButtonColor,
          cancelButtonText: _vm.confirmationDialogCancelButtonText,
          showCancelButton: _vm.confirmationDialogShowCancelButton,
          isLoading: _vm.isLoading,
        },
        on: {
          onSubmitClicked: _vm.onConfirmationDialogSubmitClicked,
          onCancelClicked: _vm.onConfirmationDialogCancelClicked,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }